import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { faQuestionCircle, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useRef } from 'react';

const Modal = ({
  isOpen,
  onClose,
  children,
  titleName,
  contentWidth,
  hideHeader,
  detailHeight,
  titleToolTip,
  disableBackdropClose,
  hideClosingX,
  titleSuffix
}) => {
  const modalContentRef = useRef();

  if (!isOpen) {
    return null;
  }


  const shakeModal = () => {
    modalContentRef.current.classList.add('shakeModal');
    setTimeout(() => modalContentRef.current.classList.remove('shakeModal'), 750);
  };

  return ReactDOM.createPortal(
    <div className='modal-overlay' onClick={disableBackdropClose ?()=> shakeModal() : onClose}>
      <div
        style={{ '--content-width': contentWidth }}
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        ref={modalContentRef}>
        <div className={`modal-header ${hideHeader ? 'd-none' : ''}`}>
          <div className="modal-header-in w-100 d-flex justify-content-between align-items-center">
            <div className="d-flex gap-2">
              {typeof(titleName) === 'object' && <h3 className="primary-title mb-0">{titleName}</h3>}
              {typeof(titleName) != 'object' && <><h3 className="primary-title mb-0" dangerouslySetInnerHTML={{ __html: titleName }}></h3><span className='fs-7 mt-2'>{titleSuffix}</span></>}
              {titleToolTip && (
                <OverlayTrigger
                  key="modal-overlay"
                  placement="top"
                  overlay={
                    <Tooltip className="modal-title-tooltip">
                      <div dangerouslySetInnerHTML={{ __html: titleToolTip }}></div>
                    </Tooltip>
                  }>
                  <FontAwesomeIcon className="modal-title-icon" icon={faQuestionCircle} />
                </OverlayTrigger>
              )}
            </div>
            {!hideClosingX && <FontAwesomeIcon className="ms-2" size="5x" icon={faXmark} onClick={()=>onClose()} />}
          </div>
        </div>
        <div style={{ '--detail-height': detailHeight }} className="modal-details">
          {children}
        </div>
      </div>
    </div>,
    document.getElementById('modal')
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  titleName: PropTypes.string,
  contentWidth: PropTypes.string,
  hideHeader: PropTypes.bool,
  titleToolTip: PropTypes.string,
  detailHeight: PropTypes.string,
  disableBackdropClose: PropTypes.bool,
  hideClosingX: PropTypes.bool,
  titleSuffix: PropTypes.string,
};

export default Modal;
